import { FC } from 'react';
import { Button } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

type Props = {
  isCancelDisabled?: boolean;
  disabled?: boolean;
  onRangeSelectCancel: () => void;
  onDateRangeSubmit: () => void;
  onClearCustomPeriod?: () => void;
  applyOnChange?: boolean;
  onDone?: () => void;
};

const DatePickerFooter: FC<Props> = ({
  isCancelDisabled,
  disabled,
  onRangeSelectCancel,
  onDateRangeSubmit,
  onClearCustomPeriod,
  applyOnChange,
  onDone,
}) => {
  const { t } = useTranslation();

  if (applyOnChange) {
    return (
      <div className="tw-flex tw-w-full tw-justify-end tw-p-2">
        <Button variant="ghost" onClick={onDone}>
          {t('done')}
        </Button>
      </div>
    );
  }

  return (
    <div className="tw-flex tw-w-full tw-justify-between tw-p-2">
      {onClearCustomPeriod && (
        <Button variant="ghost" onClick={onClearCustomPeriod}>
          {t('clear')}
        </Button>
      )}
      <div
        className={clsx('tw-flex tw-gap-x-2', {
          'tw-ml-auto': !onClearCustomPeriod,
          'tw-w-full': !onClearCustomPeriod,
        })}
      >
        <Button
          variant="light"
          onClick={onRangeSelectCancel}
          disabled={isCancelDisabled}
          className={clsx({ 'tw-flex-1': !onClearCustomPeriod })}
        >
          {t('cancel')}
        </Button>
        <Button
          disabled={disabled}
          onClick={onDateRangeSubmit}
          className={clsx({ 'tw-flex-1': !onClearCustomPeriod })}
        >
          {t('apply')}
        </Button>
      </div>
    </div>
  );
};

export default DatePickerFooter;
